module.exports = "<div class=\"ot-logo\" ng-class=\"{'ot-active':vm.isClickable()}\" ng-click=\"vm.click()\">\n  <div ng-class=\"vm.getImageClass()\"></div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/common/logo.html
 ** module id = 254
 ** module chunks = 1
 **/